import { Component, OnInit } from '@angular/core';
import { Colaborador } from '../Modelos/Colaborador';
import { Intermediario } from '../Modelos/Intermediario';
import { IntermediariosService } from '../poliza/intermediarios/intermediarios.service';
import { PolizaService } from '../poliza/poliza.service';
import { ParametrizacionEnlacesService } from './parametrizacion-enlaces.service';

declare let mostrarLoader: Function;
declare let ocultarLoader: Function;
declare let mostrarToast: Function;
declare let abrirModal: Function;
declare let cerrarModal: Function;
declare let soloLetras: Function;
declare let soloLetrasSinEspacios: Function;
declare let validarFormatoCorreo: Function;

@Component({
  selector: 'app-parametrizacion-enlaces',
  templateUrl: './parametrizacion-enlaces.component.html'
})
export class ParametrizacionEnlacesComponent implements OnInit {

  intermediarioABuscar: string;
  intermediario: Intermediario;
  colaboradoresAsociados: Colaborador[]=[];
  colaborador: Colaborador;
  tiposDocumento: any;
  flagNuevoColaborador: boolean;
  aplicaciones: any[];

  constructor(private parametrizacionEnlacesService: ParametrizacionEnlacesService,
              private intermediariosService: IntermediariosService,
              private polizaService: PolizaService) { }

  async ngOnInit() {
    this.tiposDocumento=[
        ...(await (this.polizaService.consultarTiposDocumento())).map(element => { return {value: element.codigoTipoDocumento, text: element.nombreTipoDocumento}})
    ];
    this.intermediario=null;
    this.intermediarioABuscar="";
    this.flagNuevoColaborador=false;
    this.aplicaciones=await this.parametrizacionEnlacesService.consultarAplicaciones();
    this.restablecerColaborador();
    this.restablecerAplicaciones();
    ocultarLoader();
  }

  restablecerColaborador() {
    let colaborador: Colaborador={
      vc_NombreUno: "",
      vc_NombreDos: "",
      vc_ApellidoUno: "",
      vc_ApellidoDos: "",
      vc_Email: "",
      vc_Contrasena: null,
      confirmarContrasena: "",
      estado: false,
      inSnActualizacion: 0,
      in_CodColaborador: 0,
      in_Cod_tipo_doc: null,
      in_Estado: 0,
      in_SnRecClave: 1,
      in_Usu_login: (this.intermediario)?parseInt(this.intermediario.clave):0,
      in_Usu_tipo: (this.intermediario)?this.intermediario.cod_tipo_inter:0,
      sdFechaRegistro: null,
      usuDocumentoInter: "",
      usuNombreInter: "",
      vcCod_UsuarioSISE: "",
      vcMensaje: "",
      vc_Nro_documento: ""
    };
    this.colaborador=colaborador;
  }

  restablecerAplicaciones() {
    if(this.aplicaciones)
      this.aplicaciones.forEach(x => x.estado=false);
  }

  async consultarIntermediario(){
    if(!this.intermediarioABuscar){
      mostrarToast("El campo debe ser diligenciado.");
      return;
    }
    mostrarLoader();
    this.intermediario=await this.intermediariosService.consultarIntermediario(
      "I",
      parseInt(this.intermediarioABuscar),
      0, 0, 0
    );

      if(!this.intermediario){
        mostrarToast("No se encuentra el intermediario, revise e intente nuevamente.");
        this.colaboradoresAsociados=[];
      }
      else{
        this.restablecerColaborador();
        this.consultarColaboradoresAsociados();
      }

      ocultarLoader();
  }

  async consultarColaboradoresAsociados() {
    let resultado=await this.parametrizacionEnlacesService.consultarColaboradores(
      parseInt(this.intermediario.clave),
      this.intermediario.cod_tipo_inter
    );

    if(resultado.length==0){
      mostrarToast("No se encuentran colaboradores asociados.");
      this.colaboradoresAsociados=[];
    }
    else{
      this.colaboradoresAsociados=resultado;
      this.intermediarioABuscar="";
    }
  }

  async consultarColaborador(codigoColaborador: number){
    mostrarLoader();
    this.colaborador=(await this.parametrizacionEnlacesService.consultarColaborador(codigoColaborador))[0];
    this.colaborador.estado=(this.colaborador.in_Estado==1);
    this.colaborador.confirmarContrasena=this.colaborador.vc_Contrasena;
    let aplicacionesColaborador: any[]=await this.parametrizacionEnlacesService.consultarAplicacionesColaborador(this.colaborador.in_CodColaborador);
    aplicacionesColaborador.forEach(x => {
      let aplicacionEncontrada = this.aplicaciones.find(y => y.inCodAplicacion==x.in_CodAplicacion);
      if (aplicacionEncontrada) {
        aplicacionEncontrada.estado = true;
      }
    });
    abrirModal("modalColaborador", false);
    ocultarLoader();
  }

  abrirModalNuevoColaborador(){
    this.restablecerColaborador();
    this.flagNuevoColaborador=true;
    abrirModal("modalColaborador", false);
  }

  cerrarModalColaborador(){
    this.flagNuevoColaborador=false;
    this.restablecerAplicaciones();
    this.restablecerColaborador();
    cerrarModal("modalColaborador");
  }

  soloLetrasSinEspacios(modelo, propiedad){
    modelo[propiedad] = soloLetrasSinEspacios(modelo[propiedad]);
  }

  soloLetras(modelo, propiedad){
    if(modelo[propiedad])
      modelo[propiedad]=soloLetras(modelo[propiedad]);
  }

  async guardarColaborador(){
    if (this.flagNuevoColaborador) {
        if (!this.colaborador.vc_Contrasena ||
          !this.colaborador.in_Cod_tipo_doc ||
          !this.colaborador.vc_ApellidoUno ||
          !this.colaborador.vc_NombreUno){
          mostrarToast('Por favor Complete todos Los Campos.');
          return;
        }
        if (this.colaborador.confirmarContrasena!=this.colaborador.vc_Contrasena){
          mostrarToast('Las contraseñas no coinciden.');
          return;
        }
     }
    let result=await this.parametrizacionEnlacesService.guardarColaborador(this.colaborador, this.flagNuevoColaborador);
    if (result) {
      try {
        if (this.flagNuevoColaborador) {
          this.colaborador = result[0];
        }
        let aplicacionesSeleccionadas=this.aplicaciones.filter(x => x.estado);
        if(aplicacionesSeleccionadas.length>0){
          aplicacionesSeleccionadas.forEach(async (x, i) =>
            await this.parametrizacionEnlacesService.actualizarAplicacion(
              this.colaborador.in_CodColaborador,
              parseInt(this.intermediario.clave),
              this.intermediario.cod_tipo_inter,
              x.inCodAplicacion,
              (i==0))
          );
        }

        mostrarToast("Colaborador actualizado correctamente.");
        this.consultarColaboradoresAsociados();
        this.cerrarModalColaborador();
      }
      catch(e){
        mostrarToast("Ocurrió un problema al actualizar las aplicaciones.")
      }
    }
  }

  validarClaveIntermediario(){
    this.intermediarioABuscar = this.intermediarioABuscar.replace(/\D/g, "");
    if(this.intermediarioABuscar.length > 9)
      this.intermediarioABuscar = this.intermediarioABuscar.slice(0, 8);
  }

  validarEmail(modelo, propiedad){
    let correo=modelo[propiedad];
    if(correo.length>0)
        if(!validarFormatoCorreo(modelo[propiedad])){
            mostrarToast("El formato de correo no es válido.");
            modelo[propiedad]="";
        }
  }
}
